import { mutate } from '../../../../../../../common/graphql';
import { ADMIN_GAME_QUERY } from '../../../../../../../common/graphql/games/game-admin-graphql';
import {
  ADMIN_SUBMISSION_SYNC_VIDEOS_MUTATION,
  AdminSubmissionSyncVideosInput,
  AdminSynchroniseVideosMutation,
} from '@crazygames/graph-types/submission/admin-submission-sync-videos-input.type';

export function synchroniseVideos(input: AdminSubmissionSyncVideosInput, gameSlug: string) {
  return mutate<AdminSubmissionSyncVideosInput, AdminSynchroniseVideosMutation>(ADMIN_SUBMISSION_SYNC_VIDEOS_MUTATION, input, {
    refetchQueries: [{ query: ADMIN_GAME_QUERY, variables: { slug: gameSlug } }],
    awaitRefetchQueries: true,
  });
}
